import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[AssetCategories SetFilter] Action',
  ResetFilter: '[AssetCategories ResetFilter] Action',
}

const initialAssetCategoriesState: IAssetCategoriesState = {
  filter: {
    status: '',
    active: true,
  },
}

export interface IAssetCategoriesState {
  filter?: {
    status: string
    active: boolean
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-AssetCategories', whitelist: ['filter']},
  (
    state: IAssetCategoriesState = initialAssetCategoriesState,
    action: ActionWithPayload<IAssetCategoriesState>
  ) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialAssetCategoriesState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}

export function* saga() {}
